export default __webpack_public_path__ + "static/media/hispanicPeople16.4e1df8b6.svg";